export default __webpack_public_path__ + "static/media/screenshot_org_report_purple.12ac8dc1.png";